import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import LoadingSpinner from "../../components/loaders/LoadingSpinner.vue";
import { IntersectionPaginationOption, IntersectionStateChanger } from '@/utils/types';


  export type AutoCompleteValue = { text: string, value: string | number } | string;

export default /*#__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  props: {
    disabled: { type: Boolean, default: false },
    value: null,
    items: null,
    labelText: { default: '' },
    loading: { type: Boolean },
    appendIcon: { default: "$icon_arrow_down" },
    stopIconTransform: { type: Boolean, default: false },
    isAttached: { type: Boolean, default: false },
    paginated: { type: Boolean, default: false },
    noDataText: { default: '' }
  },
  emits: ["input", "search", "infinite"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value?: AutoCompleteValue): void;
  (e: "search", value: { searchText: string | undefined | null, state: IntersectionStateChanger }): void;
  (e: "infinite", value: IntersectionStateChanger): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { disabled: boolean, value: AutoCompleteValue, items: Array<AutoCompleteValue>, labelText: string, loading?: boolean, appendIcon: string, stopIconTransform: boolean, isAttached: boolean, paginated: boolean, noDataText: string };





const selectedItem = computed({
  get: () => props.value,
  set: (newValue) => {
    emit('input', newValue);
  }
})

function handleIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver, isIntersecting: boolean) {
  if(isIntersecting) {
    if(paginationRef.value.completed) return;
    paginationRef.value.loaded = false;
    emit('infinite', state);
  }
}

const paginationRef = ref<IntersectionPaginationOption>({
  loaded: false,
  completed: false,
  searchText: undefined, 
  bounceTimer: undefined
})

watch(
  () => paginationRef.value.searchText,
  (newValue, oldValue) => {
    if(!props.paginated) return;
    if(newValue === oldValue) return;
    state.reset();
    
    if(paginationRef.value.searchText?.length && paginationRef.value.searchText === props.value.text) { // watcher for searchText will be called whenever an option is selected from dropdown, to avoid search in the case the condition is added
      return;
    }
    // debounce for the search
    clearTimeout(paginationRef.value.bounceTimer);
    paginationRef.value.bounceTimer = setTimeout(() => {
      emit('search', {searchText: paginationRef.value.searchText, state});
    }, 500);
  }
)

const state: IntersectionStateChanger = {
  loaded: () => {
    paginationRef.value.loaded = true;
  },
  completed: () => {
    paginationRef.value.completed = true;
  },
  reset: () => {
    paginationRef.value.loaded = false;
    paginationRef.value.completed = false;
  }
};

return { __sfc: true,props, emit, selectedItem, handleIntersection, paginationRef, state, LoadingSpinner }
}

})